export default __webpack_public_path__ + "static/media/coronary-flow-logo-light.5d67a1c3.png";